import React from 'react'
import { LocalCustomDateTime } from '../LocalCustomDateTime'
import { formatConstants } from '@ztechapps/common.utils'
import type { CommonDateTimeProps } from '../types/CommonDateTimeProps'

export type LocalDateTimeProps = Omit<CommonDateTimeProps, 'format'>

export const LocalDateTime = ({ value, timeZone }: LocalDateTimeProps) => {
  return <LocalCustomDateTime {...{ timeZone, value, format: formatConstants.dateTime }} />
}
